function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { parse, filter } from '@sky-uk-ott/core-video-sdk-js-external-txml/dist/txml';
function nodeMatchesTagInVmapNamespace(node, tagName) {
    return [
        tagName,
        "vmap:".concat(tagName)
    ].includes(node.tagName);
}
function adToNonLinearAdData(ad, breakStart, breakEnd) {
    var impressions = filter([
        ad
    ], function(node) {
        return nodeMatchesTagInVmapNamespace(node, 'Impression');
    }).map(function(node) {
        return node.children[0];
    });
    var onClicks = filter([
        ad
    ], function(node) {
        return nodeMatchesTagInVmapNamespace(node, 'NonLinearClickTracking');
    }).map(function(node) {
        return node.children[0];
    });
    var variants = filter([
        ad
    ], function(node) {
        return nodeMatchesTagInVmapNamespace(node, 'NonLinear');
    }).map(function(nonLinearNode) {
        return [
            nonLinearNode,
            filter([
                nonLinearNode
            ], function(node) {
                return nodeMatchesTagInVmapNamespace(node, 'StaticResource');
            })[0]
        ];
    }).filter(function(param) {
        var _param = _sliced_to_array(param, 2), _ = _param[0], resource = _param[1];
        return !!resource;
    }).map(function(param) {
        var _param = _sliced_to_array(param, 2), nonLinearNode = _param[0], resource = _param[1];
        return {
            width: parseInt(nonLinearNode.attributes['width'], 10),
            height: parseInt(nonLinearNode.attributes['height'], 10),
            mimeType: resource.attributes['creativeType'],
            resourceUri: resource.children[0]
        };
    });
    return {
        variants: variants,
        adStartedBeacons: _to_consumable_array(new Set(_to_consumable_array(breakStart).concat(_to_consumable_array(impressions)))),
        adFinishedBeacons: _to_consumable_array(new Set(breakEnd)),
        adClickedBeacons: _to_consumable_array(new Set(onClicks))
    };
}
function adBreakToNonLinearAdData(adBreak) {
    var _filter_reduce = filter([
        adBreak
    ], function(node) {
        return nodeMatchesTagInVmapNamespace(node, 'Tracking');
    }).reduce(function(acc, eventNode) {
        if (!acc[eventNode.attributes['event']]) {
            acc[eventNode.attributes['event']] = [];
        }
        acc[eventNode.attributes['event']].push(eventNode.children[0]);
        return acc;
    }), _filter_reduce_breakStart = _filter_reduce.breakStart, breakStart = _filter_reduce_breakStart === void 0 ? [] : _filter_reduce_breakStart, _filter_reduce_breakEnd = _filter_reduce.breakEnd, breakEnd = _filter_reduce_breakEnd === void 0 ? [] : _filter_reduce_breakEnd;
    var ads = filter([
        adBreak
    ], function(node) {
        return nodeMatchesTagInVmapNamespace(node, 'Ad');
    });
    if (ads.length === 0) {
        // empty ad
        return [
            {
                variants: [],
                adStartedBeacons: _to_consumable_array(new Set(breakStart)),
                adClickedBeacons: [],
                adFinishedBeacons: _to_consumable_array(new Set(breakEnd))
            }
        ];
    }
    return ads.map(function(ad) {
        return adToNonLinearAdData(ad, breakStart, breakEnd);
    }).filter(function(ad) {
        return !!ad;
    });
}
export function extractNonLinearAdsFromVmap(vmapDocument) {
    var parsedVmap = parse(vmapDocument).filter(function(node) {
        return nodeMatchesTagInVmapNamespace(node, 'VMAP');
    });
    return filter(parsedVmap, function(node) {
        return nodeMatchesTagInVmapNamespace(node, 'AdBreak') && node.attributes['breakType'] === 'nonlinear';
    }).map(adBreakToNonLinearAdData).reduce(function(memo, x) {
        return _to_consumable_array(memo).concat(_to_consumable_array(x));
    }, []);
}

//# sourceMappingURL=vmap-non-linear-ad-extractor.js.map